import { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from '../SuggestedActivities.module.css';
import flightStyles from './flights.module.css';
 export const API_URL =  import.meta.env.VITE_API_URL;
import { useTripInfo } from '../../context';

/* ----------------------------------------------------
 * Category navigation (mirrors the Suggestions header)
 * ---------------------------------------------------- */
const mainCategories = [
    {
        name: 'Activities',
        link: '/suggestions',
        icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="m233-80 54-122q-14-11-27-21.5T235-246q-8 3-15.5 4.5T203-240q-33 0-56.5-23.5T123-320q0-20 8.5-36.5T155-384q-8-23-11-46.5t-3-49.5q0-26 3-49.5t11-46.5q-15-11-23.5-27.5T123-640q0-33 23.5-56.5T203-720q9 0 16.5 1.5T235-714q33-36 75.5-60t90.5-36q5-30 27.5-50t52.5-20q30 0 52.5 20.5T561-810q48 12 90.5 35.5T727-716q8-3 15-4.5t15-1.5q33 0 56.5 23.5T837-642q0 20-8 35.5T807-580q8 24 11 49t3 51q0 26-3 50.5T807-382q14 11 22 26.5t8 35.5q0 33-23.5 56.5T757-240q-8 0-15-1.5t-15-4.5q-12 12-24.5 23.5T675-200l52 120h-74l-38-88q-14 6-27 10.5t-27 7.5q-5 29-27.5 49.5T481-80q-30 0-52.5-20T401-150q-15-3-28.5-7.5T345-168l-38 88h-74Zm248-360q24 0 42-17t18-43q0-24-18-42t-42-18q-26 0-43 18t-17 42q0 26 17 43t43 17Z" /></svg>,
    },
    {
        name: 'Hotels',
        link: '/suggestions/hotels',
        icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="M40-200v-600h80v400h320v-320h320q66 0 113 47t47 113v360h-80v-120H120v120H40Zm240-240q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm240 40h320v-160q0-33-23.5-56.5T760-640H520v240ZM280-520q17 0 28.5-11.5T320-560q0-17-11.5-28.5T280-600q-17 0-28.5 11.5T240-560q0 17 11.5 28.5T280-520Z" /></svg>,
    },
    {
        name: 'Car Rentals',
        link: '/suggestions/car-rentals',
        icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="M240-200v40q0 17-11.5 28.5T200-120h-40q-17 0-28.5-11.5T120-160v-320l84-240q6-18 21.5-29t34.5-11h440q19 0 34.5 11t21.5 29l84 240v320q0 17-11.5 28.5T800-120h-40q-17 0-28.5-11.5T720-160v-40H240Zm-8-360h496l-42-120H274l-42 120Zm68 240q25 0 42.5-17.5T360-380q0-25-17.5-42.5T300-440q-25 0-42.5 17.5T240-380q0 25 17.5 42.5T300-320Zm360 0q25 0 42.5-17.5T720-380q0-25-17.5-42.5T660-440q-25 0-42.5 17.5T600-380q0 25 17.5 42.5T660-320Z" /></svg>,
    },
    {
        name: 'Flights',
        link: '/suggestions/flights',
        icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="M280-80v-100l120-84v-144L80-280v-120l320-224v-176q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800v176l320 224v120L560-408v144l120 84v100l-200-60-200 60Z" /></svg>,
    },
    {
        name: 'Food & Drink',
        link: '/suggestions/food',
        icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="m175-120-56-56 410-410q-18-42-5-95t57-95q53-53 118-62t106 32q41 41 32 106t-62 118q-42 44-95 57t-95-5l-50 50 304 304-56 56-304-302-304 302Zm118-342L173-582q-54-54-54-129t54-129l248 250-128 128Z" /></svg>,
    },
    {
        name: 'Tours',
        link: '/suggestions/tours',
        icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="M200-80v-800h80v80h560l-80 200 80 200H280v320h-80Zm80-640v240-240Zm220 200q33 0 56.5-23.5T580-600q0-33-23.5-56.5T500-680q-33 0-56.5 23.5T420-600q0 33 23.5 56.5T500-520Zm-220 40h442l-48-120 48-120H280v240Z" /></svg>,
    },
];

const sortOptions = [
    { id: 'best', name: 'Best' },
    { id: 'cheapest', name: 'Cheapest' },
    { id: 'fastest', name: 'Fastest' },
    { id: 'earliest', name: 'Earliest departure' },
];

const travelClasses = [
    { id: '1', name: 'Economy' },
    { id: '2', name: 'Premium economy' },
    { id: '3', name: 'Business' },
    { id: '4', name: 'First' },
];

const fmtDuration = (min) => {
    if (min == null) return '';
    return `${Math.floor(min / 60)}h ${String(min % 60).padStart(2, '0')}m`;
};

const isoDate = (offsetDays) => {
    const d = new Date();
    d.setDate(d.getDate() + offsetDays);
    return d.toISOString().split('T')[0];
};

/* Inline icons */
const PlaneIcon = (p) => <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor" {...p}><path d="M340-120v-66l80-60v-166L120-280v-66l300-200v-194q0-25 17.5-42.5T480-800q25 0 42.5 17.5T540-740v194l300 200v66L540-412v166l80 60v66l-140-40-140 40Z" /></svg>;
const ChevronIcon = (p) => <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="currentColor" {...p}><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" /></svg>;
const SwapIcon = () => <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="currentColor"><path d="M320-440 80-680l240-240 57 57-144 143h455v80H233l144 144-57 56Zm320-80-57-57 144-143H272v-80h455L583-944l57-56 240 240-240 240Z" transform="translate(0 240)" /></svg>;
const WifiIcon = () => <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="M480-120 0-600q95-97 219.5-148.5T480-800q137 0 261.5 51.5T960-600L480-120Zm0-114 366-366q-78-59-172-89.5T480-720q-100 0-194 30.5T114-600l366 366Z" /></svg>;
const MealIcon = () => <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="M280-80v-366q-51-14-85.5-56T160-600v-280h80v280h40v-280h80v280h40v-280h80v280q0 56-34.5 98T400-446v366h-80Zm400 0v-320H560v-280q0-83 58.5-141.5T760-880v800h-80Z" /></svg>;
const PowerIcon = () => <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="m422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Z" /></svg>;
const LeafIcon = () => <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="currentColor"><path d="M420-80q-92 0-156-64T200-300q0-77 47.5-145T372-580q67-50 120.5-115T580-840q21 49 31 91t10 79q0 90-49.5 168T420-380q-2 23 2 44t14 40q42-8 79.5-30t66.5-56q-8 20-12 41t-4 43q0 92-46 155T420-80Z" /></svg>;
const SeatIcon = () => <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="M240-240v-360q0-17 11.5-28.5T280-640q17 0 28.5 11.5T320-600v280h320v80H240Zm120-160q-33 0-56.5-23.5T280-480v-200q0-33 23.5-56.5T360-760h120q33 0 56.5 23.5T560-680v200q0 33-23.5 56.5T480-400H360Zm320 240v-80h80q17 0 28.5 11.5T800-160h-120Z" /></svg>;
const MoonIcon = () => <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="currentColor"><path d="M480-120q-150 0-255-105T120-480q0-150 105-255t255-105q14 0 27.5 1t26.5 3q-41 29-65.5 75.5T444-660q0 90 63 153t153 63q55 0 101-24.5t75-65.5q2 13 3 26.5t1 27.5q0 150-105 255T480-120Z" /></svg>;
const AlertIcon = () => <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="currentColor"><path d="m40-120 440-760 440 760H40Zm440-120q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Z" /></svg>;
const BagIcon = () => <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="currentColor"><path d="M280-120q-33 0-56.5-23.5T200-200v-440q0-33 23.5-56.5T280-720h80v-80q0-33 23.5-56.5T440-880h80q33 0 56.5 23.5T600-800v80h80q33 0 56.5 23.5T760-640v440q0 33-23.5 56.5T680-120q0 17-11.5 28.5T640-80q-17 0-28.5-11.5T600-120H360q0 17-11.5 28.5T320-80q-17 0-28.5-11.5T280-120Zm160-600h80v-80h-80v80ZM360-280q17 0 28.5-11.5T400-320v-200q0-17-11.5-28.5T360-560q-17 0-28.5 11.5T320-520v200q0 17 11.5 28.5T360-280Zm240 0q17 0 28.5-11.5T640-320v-200q0-17-11.5-28.5T600-560q-17 0-28.5 11.5T560-520v200q0 17 11.5 28.5T600-280Z" /></svg>;

/* ----------------------------------------------------
 * Airport autocomplete field.
 * The user types a city / state / airport name; we query the backend
 * which returns matching airports. We keep the resolved IATA code so the
 * search only ever sends the code.
 * ---------------------------------------------------- */
function AirportField({ field, onChange, label, icon, placeholder }) {
    const [results, setResults] = useState([]);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [active, setActive] = useState(-1);
    const boxRef = useRef(null);
    const debounceRef = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const runSearch = (q) => {
        clearTimeout(debounceRef.current);
        if (!q || q.trim().length < 2) {
            setResults([]);
            return;
        }
        debounceRef.current = setTimeout(async () => {
            try {
                setLoading(true);
                const res = await fetch(`${API_URL}/flights/airports?q=${encodeURIComponent(q)}`, {
                    credentials: 'include',
                });
                const data = await res.json();
                setResults(data.results || []);
                setOpen(true);
            } catch {
                /* ignore – the backend still resolves free text on search */
            } finally {
                setLoading(false);
            }
        }, 250);
    };

    const handleType = (e) => {
        onChange({ query: e.target.value, code: null });
        setActive(-1);
        runSearch(e.target.value);
    };

    const choose = (a) => {
        onChange({ query: `${a.city}${a.region ? `, ${a.region}` : ''}`, code: a.code });
        setResults([]);
        setOpen(false);
        setActive(-1);
    };

    const handleKey = (e) => {
        if (!open || !results.length) return;
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setActive((i) => (i + 1) % results.length);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setActive((i) => (i <= 0 ? results.length - 1 : i - 1));
        } else if (e.key === 'Enter' && active >= 0) {
            e.preventDefault();
            choose(results[active]);
        } else if (e.key === 'Escape') {
            setOpen(false);
        }
    };

    return (
        <div className={flightStyles.searchField}>
            <label className={flightStyles.fieldLabel}>{label}</label>
            <div className={flightStyles.autoWrap} ref={boxRef}>
                <div className={flightStyles.fieldShell}>
                    {icon}
                    <input
                        className={flightStyles.fieldInput}
                        style={{ paddingRight: field.code ? '3.5rem' : undefined }}
                        value={field.query}
                        placeholder={placeholder}
                        onChange={handleType}
                        onKeyDown={handleKey}
                        onFocus={() => results.length && setOpen(true)}
                        autoComplete="off"
                    />
                    {field.code && <span className={flightStyles.autoCode}>{field.code}</span>}
                </div>
                {open && (
                    <div className={flightStyles.autoDropdown}>
                        {loading && <div className={flightStyles.autoEmpty}>Searching…</div>}
                        {!loading && results.length === 0 && (
                            <div className={flightStyles.autoEmpty}>No airports found — try a nearby city</div>
                        )}
                        {results.map((a, i) => (
                            <div
                                key={a.code}
                                className={`${flightStyles.autoItem} ${i === active ? flightStyles.autoItemActive : ''}`}
                                onMouseEnter={() => setActive(i)}
                                onMouseDown={(e) => {
                                    e.preventDefault();
                                    choose(a);
                                }}
                            >
                                <span className={flightStyles.autoItemCode}>{a.code}</span>
                                <span className={flightStyles.autoItemText}>
                                    <span className={flightStyles.autoItemCity}>
                                        {a.city}{a.region ? `, ${a.region}` : ''}
                                    </span>
                                    <span className={flightStyles.autoItemName}>{a.name} · {a.country}</span>
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export function FlightsPage() {
    const navigate = useNavigate();
    const { trip_name } = useTripInfo();

    // --- Search form state ---
    const [tripType, setTripType] = useState('1'); // 1 round, 2 oneway
    const [from, setFrom] = useState({ query: 'New York, NY', code: 'JFK' });
    const [to, setTo] = useState({ query: 'Paris', code: 'CDG' });
    const [outboundDate, setOutboundDate] = useState(isoDate(21));
    const [returnDate, setReturnDate] = useState(isoDate(28));
    const [adults, setAdults] = useState('1');
    const [travelClass, setTravelClass] = useState('1');
    const [carryOnBags, setCarryOnBags] = useState('0');
    const [checkedBags, setCheckedBags] = useState('0');

    // Lazily-fetched fares + baggage per flight (keyed by flight id).
    const [bookingData, setBookingData] = useState({});

    // --- Results / UI state ---
    const [sortBy, setSortBy] = useState('best');
    const [showFilters, setShowFilters] = useState(false);
    const [maxPrice, setMaxPrice] = useState(null);
    const [stopFilter, setStopFilter] = useState({ nonstop: false, oneStop: false });
    const [selectedAirlines, setSelectedAirlines] = useState([]);
    const [expandedId, setExpandedId] = useState(null);

    const [flights, setFlights] = useState([]);
    const [priceInsights, setPriceInsights] = useState(null);
    const [searchMeta, setSearchMeta] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [hasSearched, setHasSearched] = useState(false);

    const currencyFmt = useMemo(() => {
        const code = searchMeta?.currency || 'USD';
        try {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: code, maximumFractionDigits: 0 });
        } catch {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
        }
    }, [searchMeta]);
    const fmtPrice = (n) => (n == null ? '—' : currencyFmt.format(n));

    const fetchFlights = useCallback(async () => {
        const departureValue = (from.code || from.query || '').trim();
        const arrivalValue = (to.code || to.query || '').trim();
        if (!departureValue || !arrivalValue || !outboundDate) {
            setError('Please enter an origin, destination, and departure date.');
            return;
        }
        setLoading(true);
        setError('');
        setExpandedId(null);
        try {
            const params = new URLSearchParams({
                departure_id: departureValue,
                arrival_id: arrivalValue,
                outbound_date: outboundDate,
                type: tripType,
                adults,
                travel_class: travelClass,
            });
            if (tripType === '1' && returnDate) params.set('return_date', returnDate);
            if (Number(carryOnBags) > 0) params.set('carry_on_bags', carryOnBags);
            if (Number(checkedBags) > 0) params.set('checked_bags', checkedBags);
            setBookingData({});

            const res = await fetch(`${API_URL}/flights?${params.toString()}`, {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
            });

            if (res.status === 401) {
                navigate('/login');
                return;
            }

            const data = await res.json();
            if (!res.ok) {
                setError(data.message || data.error || 'Could not load flights. Please try again.');
                setFlights([]);
            } else {
                setFlights(data.flights || []);
                setPriceInsights(data.priceInsights || null);
                setSearchMeta(data.search || null);
                // Reset filters to fit the new result set
                setMaxPrice(null);
                setStopFilter({ nonstop: false, oneStop: false });
                setSelectedAirlines([]);
            }
        } catch (e) {
            console.error('Flights fetch failed:', e);
            setError('Network error while fetching flights. Please check your connection and try again.');
            setFlights([]);
        } finally {
            setLoading(false);
            setHasSearched(true);
        }
    }, [from, to, outboundDate, returnDate, tripType, adults, travelClass, carryOnBags, checkedBags, navigate]);

    // Lazily fetch fares + baggage for a single flight on demand.
    const loadBookingOptions = useCallback(async (f) => {
        if (!f.bookingToken || !searchMeta) return;
        setBookingData((prev) => ({ ...prev, [f.id]: { loading: true, error: '', data: null } }));
        try {
            const params = new URLSearchParams({
                booking_token: f.bookingToken,
                departure_id: searchMeta.departure_id,
                arrival_id: searchMeta.arrival_id,
                outbound_date: searchMeta.outbound_date,
                type: searchMeta.type,
                currency: searchMeta.currency || 'USD',
            });
            if (searchMeta.return_date) params.set('return_date', searchMeta.return_date);

            const res = await fetch(`${API_URL}/flights/booking-options?${params.toString()}`, {
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
            });
            const data = await res.json();
            if (!res.ok) {
                setBookingData((prev) => ({ ...prev, [f.id]: { loading: false, error: data.message || 'Could not load baggage info.', data: null } }));
            } else {
                setBookingData((prev) => ({ ...prev, [f.id]: { loading: false, error: '', data } }));
            }
        } catch (e) {
            console.error('Booking options fetch failed:', e);
            setBookingData((prev) => ({ ...prev, [f.id]: { loading: false, error: 'Network error loading baggage info.', data: null } }));
        }
    }, [searchMeta]);

    // POST to Google's booking endpoint (it requires a form POST with post_data).
    const bookNow = (url, postData) => {
        if (!url) return;
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = url;
        form.target = '_blank';
        if (postData) {
            postData.split('&').forEach((pair) => {
                const idx = pair.indexOf('=');
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = decodeURIComponent(idx >= 0 ? pair.slice(0, idx) : pair);
                input.value = decodeURIComponent(idx >= 0 ? pair.slice(idx + 1) : '');
                form.appendChild(input);
            });
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    };

    // Run an initial search on mount.
    useEffect(() => {
        fetchFlights();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const swap = () => {
        setFrom(to);
        setTo(from);
    };

    const fromIcon = <PlaneIcon style={{ transform: 'rotate(45deg)' }} />;
    const toIcon = <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Z" /></svg>;

    const airlines = useMemo(
        () => [...new Set(flights.map((f) => f.airline).filter(Boolean))].sort(),
        [flights]
    );
    const priceBounds = useMemo(() => {
        const prices = flights.map((f) => f.price).filter((p) => typeof p === 'number');
        if (!prices.length) return null;
        return { min: Math.floor(Math.min(...prices)), max: Math.ceil(Math.max(...prices)) };
    }, [flights]);

    const effectiveMax = maxPrice ?? priceBounds?.max ?? 0;

    const toggleAirline = (name) =>
        setSelectedAirlines((prev) =>
            prev.includes(name) ? prev.filter((a) => a !== name) : [...prev, name]
        );

    const activeFilterCount =
        (stopFilter.nonstop ? 1 : 0) +
        (stopFilter.oneStop ? 1 : 0) +
        selectedAirlines.length +
        (maxPrice != null && priceBounds && maxPrice < priceBounds.max ? 1 : 0);

    const visibleFlights = useMemo(() => {
        let list = [...flights];
        if (maxPrice != null) list = list.filter((f) => f.price == null || f.price <= maxPrice);
        if (stopFilter.nonstop || stopFilter.oneStop) {
            list = list.filter(
                (f) =>
                    (stopFilter.nonstop && f.stops === 0) ||
                    (stopFilter.oneStop && f.stops === 1)
            );
        }
        if (selectedAirlines.length) list = list.filter((f) => selectedAirlines.includes(f.airline));

        if (sortBy === 'cheapest') list.sort((a, b) => (a.price ?? 1e9) - (b.price ?? 1e9));
        else if (sortBy === 'fastest') list.sort((a, b) => (a.durationMin ?? 1e9) - (b.durationMin ?? 1e9));
        else if (sortBy === 'earliest') list.sort((a, b) => (a.depart || '').localeCompare(b.depart || ''));
        else list.sort((a, b) => (a.price ?? 1e9) + (a.durationMin ?? 0) * 0.4 - ((b.price ?? 1e9) + (b.durationMin ?? 0) * 0.4));
        return list;
    }, [flights, maxPrice, stopFilter, selectedAirlines, sortBy]);

    const carbonClass = (diff) => {
        if (diff == null) return flightStyles.carbonNeutral;
        if (diff < -5) return flightStyles.carbonLow;
        if (diff > 5) return flightStyles.carbonHigh;
        return flightStyles.carbonNeutral;
    };

    const levelClass = (level) => {
        const l = (level || '').toLowerCase();
        if (l === 'low') return flightStyles.levelLow;
        if (l === 'high') return flightStyles.levelHigh;
        return flightStyles.levelTypical;
    };

    return (
        <div className={`${styles.root} ${styles.light}`}>
            <main className={styles.mainContent}>
                {/* Category navigation */}
                <div className={styles.categoryNavSection}>
                    <div className={styles.categoryPills}>
                        {mainCategories.map((cat) => (
                            <Link
                                to={cat.link}
                                key={cat.name}
                                className={`${styles.navPill} ${cat.name === 'Flights' ? styles.activePill : ''}`}
                            >
                                {cat.icon}
                                <span className={styles.categoryName}>{cat.name}</span>
                            </Link>
                        ))}
                    </div>
                </div>

                {/* Title */}
                <div className={styles.pageTitleSection}>
                    <div className={styles.pageHeaderGroup}>
                        <div className={styles.titleRow}>
                            <p className={styles.pageTitle}>Flights</p>
                            <div className={flightStyles.tripToggle}>
                                {[
                                    { id: '1', label: 'Round trip' },
                                    { id: '2', label: 'One way' },
                                ].map((t) => (
                                    <button
                                        key={t.id}
                                        className={`${flightStyles.tripToggleOption} ${tripType === t.id ? flightStyles.tripToggleOptionActive : ''}`}
                                        onClick={() => setTripType(t.id)}
                                    >
                                        {t.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <p className={styles.pageSubtitle}>
                            {trip_name ? `Find the best fares for "${trip_name}"` : 'Find the best fares for your trip'}
                        </p>
                    </div>
                </div>

                {/* Search panel */}
                <div className={flightStyles.searchPanel}>
                    <div className={flightStyles.searchRow}>
                        <AirportField
                            field={from}
                            onChange={setFrom}
                            label="From"
                            icon={fromIcon}
                            placeholder="City, state or airport"
                        />

                        <button className={flightStyles.swapBtn} onClick={swap} aria-label="Swap origin and destination" title="Swap">
                            <SwapIcon />
                        </button>

                        <AirportField
                            field={to}
                            onChange={setTo}
                            label="To"
                            icon={toIcon}
                            placeholder="City, state or airport"
                        />

                        <div className={flightStyles.searchField}>
                            <label className={flightStyles.fieldLabel}>Departure</label>
                            <div className={flightStyles.fieldShell}>
                                <input
                                    type="date"
                                    className={`${flightStyles.fieldInput} ${flightStyles.fieldInputPlain}`}
                                    value={outboundDate}
                                    min={isoDate(0)}
                                    onChange={(e) => setOutboundDate(e.target.value)}
                                />
                            </div>
                        </div>

                        {tripType === '1' && (
                            <div className={flightStyles.searchField}>
                                <label className={flightStyles.fieldLabel}>Return</label>
                                <div className={flightStyles.fieldShell}>
                                    <input
                                        type="date"
                                        className={`${flightStyles.fieldInput} ${flightStyles.fieldInputPlain}`}
                                        value={returnDate}
                                        min={outboundDate}
                                        onChange={(e) => setReturnDate(e.target.value)}
                                    />
                                </div>
                            </div>
                        )}

                        <button className={flightStyles.searchSubmitBtn} onClick={fetchFlights} disabled={loading}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="currentColor"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" /></svg>
                            {loading ? 'Searching…' : 'Search'}
                        </button>
                    </div>

                    <div className={flightStyles.searchExtras}>
                        <select className={flightStyles.miniSelect} value={adults} onChange={(e) => setAdults(e.target.value)}>
                            {[1, 2, 3, 4, 5, 6].map((n) => (
                                <option key={n} value={String(n)}>{n} {n === 1 ? 'passenger' : 'passengers'}</option>
                            ))}
                        </select>
                        <select className={flightStyles.miniSelect} value={travelClass} onChange={(e) => setTravelClass(e.target.value)}>
                            {travelClasses.map((c) => (
                                <option key={c.id} value={c.id}>{c.name}</option>
                            ))}
                        </select>
                        <select className={flightStyles.miniSelect} value={carryOnBags} onChange={(e) => setCarryOnBags(e.target.value)}>
                            <option value="0">Any carry-on</option>
                            {[1, 2, 3].map((n) => (
                                <option key={n} value={String(n)}>{n} carry-on{n > 1 ? 's' : ''}</option>
                            ))}
                        </select>
                        <select className={flightStyles.miniSelect} value={checkedBags} onChange={(e) => setCheckedBags(e.target.value)}>
                            <option value="0">Any checked</option>
                            {[1, 2, 3].map((n) => (
                                <option key={n} value={String(n)}>{n} checked bag{n > 1 ? 's' : ''}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Sticky controls: sort + filters */}
                <div className={styles.stickyControls}>
                    <div className={styles.searchAndSort}>
                        <p className={flightStyles.resultsCount} style={{ flexGrow: 1, minWidth: '200px' }}>
                            {loading ? 'Searching flights…'
                                : hasSearched
                                    ? <>{visibleFlights.length} of {flights.length} flights <span>· {searchMeta?.departure_id} → {searchMeta?.arrival_id}</span></>
                                    : 'Search to see flights'}
                        </p>
                        <div className={styles.sortAndFilterGroup}>
                            <button
                                className={`${styles.filterButton} ${showFilters ? styles.filterButtonActive : ''}`}
                                onClick={() => setShowFilters(!showFilters)}
                                disabled={!flights.length}
                            >
                                <span className="material-symbols-outlined">tune</span>
                                <span>Filters</span>
                                {activeFilterCount > 0 && <span className={styles.filterBadge}>{activeFilterCount}</span>}
                            </button>
                            <div className={styles.dropdown}>
                                <button className={styles.sortButton}>
                                    <span>Sort: {sortOptions.find((o) => o.id === sortBy).name}</span>
                                    <ChevronIcon className={styles.dropdownIcon} />
                                </button>
                                <div className={styles.dropdownMenu}>
                                    {sortOptions.map((option) => (
                                        <div key={option.id} onClick={() => setSortBy(option.id)}>{option.name}</div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Layout */}
                <div className={styles.mainLayoutContainer}>
                    {/* Filters */}
                    <aside className={`${styles.filterSidebar} ${!showFilters ? styles.sidebarHidden : ''}`}>
                        <div className={styles.sidebarContent}>
                            <div className={styles.sidebarHeader}>
                                <div className={styles.sidebarTitleGroup}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M440-160q-17 0-28.5-11.5T400-200v-240L168-736q-15-20-4.5-42t36.5-22h560q26 0 36.5 22t-4.5 42L560-440v240q0 17-11.5 28.5T520-160h-80Z" /></svg>
                                    <div>
                                        <h3 className={styles.sidebarTitle}>Filters</h3>
                                        <p className={styles.sidebarSubtitle}>Refine your results</p>
                                    </div>
                                </div>
                                <div className={styles.closeSidbar} onClick={() => setShowFilters(false)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" /></svg>
                                </div>
                            </div>

                            {priceBounds && (
                                <>
                                    <div className={flightStyles.rangeGroup}>
                                        <p className={flightStyles.filterGroupTitle}>Max price</p>
                                        <span className={flightStyles.rangeValue}>Up to {fmtPrice(effectiveMax)}</span>
                                        <input
                                            className={flightStyles.rangeInput}
                                            type="range"
                                            min={priceBounds.min}
                                            max={priceBounds.max}
                                            step="10"
                                            value={effectiveMax}
                                            onChange={(e) => setMaxPrice(Number(e.target.value))}
                                        />
                                    </div>
                                    <div className={flightStyles.filterDivider} />
                                </>
                            )}

                            <div>
                                <p className={flightStyles.filterGroupTitle}>Stops</p>
                                <label className={flightStyles.checkRow}>
                                    <input type="checkbox" checked={stopFilter.nonstop} onChange={(e) => setStopFilter((p) => ({ ...p, nonstop: e.target.checked }))} />
                                    Nonstop
                                    <span className={flightStyles.checkRowCount}>{flights.filter((f) => f.stops === 0).length}</span>
                                </label>
                                <label className={flightStyles.checkRow}>
                                    <input type="checkbox" checked={stopFilter.oneStop} onChange={(e) => setStopFilter((p) => ({ ...p, oneStop: e.target.checked }))} />
                                    1 stop
                                    <span className={flightStyles.checkRowCount}>{flights.filter((f) => f.stops === 1).length}</span>
                                </label>
                            </div>

                            {airlines.length > 0 && (
                                <>
                                    <div className={flightStyles.filterDivider} />
                                    <div>
                                        <p className={flightStyles.filterGroupTitle}>Airlines</p>
                                        {airlines.map((name) => (
                                            <label key={name} className={flightStyles.checkRow}>
                                                <input type="checkbox" checked={selectedAirlines.includes(name)} onChange={() => toggleAirline(name)} />
                                                {name}
                                            </label>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    </aside>

                    {/* Results */}
                    <section className={styles.contentSection}>
                        {/* Price insights */}
                        {!loading && priceInsights && (
                            <div className={flightStyles.insightsBanner}>
                                <div className={flightStyles.insightsIcon}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="currentColor"><path d="M120-120v-80l80-80v240h-80Zm160 0v-320l80-80v400h-80Zm160 0v-400l80 81v319h-80Zm160 0v-319l80-80v399h-80Zm160 0v-560l80-80v640h-80ZM120-433v-113l280-280 160 160 280-280v113L560-553 400-713 120-433Z" /></svg>
                                </div>
                                <div className={flightStyles.insightsText}>
                                    <span className={flightStyles.insightsTitle}>
                                        {priceInsights.lowest_price != null ? `Lowest price ${fmtPrice(priceInsights.lowest_price)}` : 'Price insights'}
                                    </span>
                                    {Array.isArray(priceInsights.typical_price_range) && (
                                        <span className={flightStyles.insightsSub}>
                                            Typical range {fmtPrice(priceInsights.typical_price_range[0])} – {fmtPrice(priceInsights.typical_price_range[1])}
                                        </span>
                                    )}
                                </div>
                                {priceInsights.price_level && (
                                    <span className={`${flightStyles.insightsLevel} ${levelClass(priceInsights.price_level)}`}>
                                        {priceInsights.price_level} prices
                                    </span>
                                )}
                            </div>
                        )}

                        {/* Loading skeletons */}
                        {loading && (
                            <div className={flightStyles.flightList}>
                                {Array.from({ length: 5 }).map((_, i) => <div key={i} className={flightStyles.skeletonCard} />)}
                            </div>
                        )}

                        {/* Error */}
                        {!loading && error && (
                            <div className={`${flightStyles.stateBox} ${flightStyles.stateError}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="currentColor"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" /></svg>
                                <h3 className={flightStyles.stateTitle}>Couldn’t load flights</h3>
                                <p className={flightStyles.stateText}>{error}</p>
                                <button className={flightStyles.retryBtn} onClick={fetchFlights}>Try again</button>
                            </div>
                        )}

                        {/* Empty */}
                        {!loading && !error && hasSearched && visibleFlights.length === 0 && (
                            <div className={flightStyles.stateBox}>
                                <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="currentColor"><path d="M280-80v-100l120-84v-144L80-280v-120l320-224v-176q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800v176l320 224v120L560-408v144l120 84v100l-200-60-200 60Z" /></svg>
                                <h3 className={flightStyles.stateTitle}>No flights found</h3>
                                <p className={flightStyles.stateText}>
                                    {flights.length ? 'Try adjusting your filters to see more results.' : 'Try different airports or dates to find available flights.'}
                                </p>
                            </div>
                        )}

                        {/* Results list */}
                        {!loading && !error && visibleFlights.length > 0 && (
                            <div className={flightStyles.flightList}>
                                {visibleFlights.map((f) => {
                                    const isOpen = expandedId === f.id;
                                    const carbonDiff = f.carbonEmissions?.difference_percent;
                                    return (
                                        <article key={f.id} className={flightStyles.flightCard}>
                                            <div className={flightStyles.flightMain}>
                                                {/* Airline row */}
                                                <div className={flightStyles.airlineRow}>
                                                    {f.airlineLogo ? (
                                                        <img className={flightStyles.airlineLogoImg} src={f.airlineLogo} alt={f.airline} referrerPolicy="no-referrer" />
                                                    ) : (
                                                        <div className={flightStyles.airlineLogo} style={{ backgroundColor: '#4A90E2' }}>
                                                            {(f.airline || '??').slice(0, 2).toUpperCase()}
                                                        </div>
                                                    )}
                                                    <div>
                                                        <p className={flightStyles.airlineName}>{f.airline}</p>
                                                        <p className={flightStyles.flightNumber}>
                                                            {f.flightNo}{f.airplane ? ` · ${f.airplane}` : ''}
                                                        </p>
                                                    </div>
                                                    {f.tag && (
                                                        <span className={`${flightStyles.flightTag} ${flightStyles.flightTagBest}`}>{f.tag}</span>
                                                    )}
                                                </div>

                                                {/* Schedule */}
                                                <div className={flightStyles.scheduleRow}>
                                                    <div className={flightStyles.timeBlock}>
                                                        <span className={flightStyles.time}>{f.depart || '—'}</span>
                                                        <span className={flightStyles.airportCode}>{f.from}</span>
                                                    </div>
                                                    <div className={flightStyles.pathBlock}>
                                                        <span className={flightStyles.duration}>{fmtDuration(f.durationMin)}</span>
                                                        <div className={flightStyles.pathLine}>
                                                            {f.stops > 0 && <span className={flightStyles.stopDot} style={{ left: '50%' }} />}
                                                            <span className={flightStyles.planeIcon}><PlaneIcon /></span>
                                                        </div>
                                                        <span className={`${flightStyles.stopsLabel} ${f.stops === 0 ? flightStyles.nonstop : flightStyles.hasStops}`}>
                                                            {f.stops === 0 ? 'Nonstop' : `${f.stops} stop${f.stops > 1 ? 's' : ''}${f.stopAt ? ` · ${f.stopAt}` : ''}`}
                                                        </span>
                                                    </div>
                                                    <div className={`${flightStyles.timeBlock} ${flightStyles.arrive}`}>
                                                        <span className={flightStyles.time}>{f.arrive || '—'}</span>
                                                        <span className={flightStyles.airportCode}>{f.to}</span>
                                                    </div>
                                                </div>

                                                {/* Meta chips: class, amenities, carbon, warnings */}
                                                <div className={flightStyles.metaChips}>
                                                    {f.travelClass && <span className={flightStyles.classChip}>{f.travelClass}</span>}
                                                    {f.legroom && <span className={flightStyles.amenity}><SeatIcon /> {f.legroom} legroom</span>}
                                                    {f.wifi && <span className={flightStyles.amenity}><WifiIcon /> Wi-Fi</span>}
                                                    {f.meal && <span className={flightStyles.amenity}><MealIcon /> Meal</span>}
                                                    {f.power && <span className={flightStyles.amenity}><PowerIcon /> Power</span>}
                                                    {carbonDiff != null && (
                                                        <span className={`${flightStyles.carbonChip} ${carbonClass(carbonDiff)}`}>
                                                            <LeafIcon /> {carbonDiff > 0 ? '+' : ''}{carbonDiff}% CO₂
                                                        </span>
                                                    )}
                                                    {f.overnight && <span className={flightStyles.warnChip}><MoonIcon /> Overnight</span>}
                                                    {f.oftenDelayed && <span className={`${flightStyles.warnChip} ${flightStyles.warnChipRed}`}><AlertIcon /> Often delayed</span>}
                                                </div>

                                                {/* Expand details */}
                                                {f.segments?.length > 0 && (
                                                    <>
                                                        <button
                                                            className={`${flightStyles.detailsToggle} ${isOpen ? flightStyles.detailsToggleOpen : ''}`}
                                                            onClick={() => setExpandedId(isOpen ? null : f.id)}
                                                        >
                                                            {isOpen ? 'Hide flight details' : 'View flight details'}
                                                            <ChevronIcon />
                                                        </button>

                                                        {isOpen && (
                                                            <div className={flightStyles.segmentDetails}>
                                                                {f.segments.map((seg, i) => (
                                                                    <div key={i}>
                                                                        <div className={flightStyles.segmentLeg}>
                                                                            <div className={flightStyles.legTimeline}>
                                                                                <span className={flightStyles.legDot} />
                                                                                <span className={flightStyles.legConnector} />
                                                                                <span className={flightStyles.legDot} />
                                                                            </div>
                                                                            <div className={flightStyles.legBody}>
                                                                                <div className={flightStyles.legRoute}>
                                                                                    {seg.departure_airport?.id} {seg.departTime || ''} → {seg.arrival_airport?.id} {seg.arriveTime || ''}
                                                                                </div>
                                                                                <div className={flightStyles.legMeta}>
                                                                                    {seg.departure_airport?.name} → {seg.arrival_airport?.name}
                                                                                    {seg.durationMin ? ` · ${fmtDuration(seg.durationMin)}` : ''}
                                                                                </div>
                                                                                <div className={flightStyles.legCarrier}>
                                                                                    {seg.airlineLogo && <img src={seg.airlineLogo} alt={seg.airline} referrerPolicy="no-referrer" />}
                                                                                    {seg.airline}{seg.flightNumber ? ` · ${seg.flightNumber}` : ''}{seg.travelClass ? ` · ${seg.travelClass}` : ''}
                                                                                </div>
                                                                                {seg.airplane && <div className={flightStyles.legSubMeta}>Aircraft: {seg.airplane}</div>}
                                                                                {seg.operatedBy && <div className={flightStyles.legSubMeta}>Operated by {seg.operatedBy}</div>}
                                                                                {seg.ticketAlsoSoldBy && <div className={flightStyles.legSubMeta}>Also sold by {seg.ticketAlsoSoldBy}</div>}
                                                                                {(seg.overnight || seg.oftenDelayed) && (
                                                                                    <div className={flightStyles.legAmenities}>
                                                                                        {seg.overnight && <span className={flightStyles.warnChip}><MoonIcon /> Overnight</span>}
                                                                                        {seg.oftenDelayed && <span className={`${flightStyles.warnChip} ${flightStyles.warnChipRed}`}><AlertIcon /> Often delayed 30min+</span>}
                                                                                    </div>
                                                                                )}
                                                                                {Array.isArray(seg.extensions) && seg.extensions.length > 0 && (
                                                                                    <div className={flightStyles.legAmenities}>
                                                                                        {seg.extensions.map((ext, k) => (
                                                                                            <span key={k} className={flightStyles.legAmenityTag}>{ext}</span>
                                                                                        ))}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        {f.layovers?.[i] && (
                                                                            <div className={flightStyles.layoverNote}>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="currentColor"><path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" /></svg>
                                                                                {fmtDuration(f.layovers[i].durationMin)} layover in {f.layovers[i].name || f.layovers[i].airport}
                                                                                {f.layovers[i].overnight && ' · overnight'}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ))}

                                                                {/* Carbon emissions detail */}
                                                                {f.carbonEmissions?.this_flight != null && (
                                                                    <div className={flightStyles.carbonBox}>
                                                                        <LeafIcon />
                                                                        <span>
                                                                            <strong>{Math.round(f.carbonEmissions.this_flight / 1000)} kg CO₂</strong>
                                                                            {f.carbonEmissions.typical_for_this_route != null && (
                                                                                <> · typical {Math.round(f.carbonEmissions.typical_for_this_route / 1000)} kg</>
                                                                            )}
                                                                            {carbonDiff != null && (
                                                                                <> · {carbonDiff > 0 ? '+' : ''}{carbonDiff}% vs typical</>
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                )}

                                                                {/* Group-level extensions (baggage, change policy, etc.) */}
                                                                {Array.isArray(f.extensions) && f.extensions.length > 0 && (
                                                                    <div className={flightStyles.legAmenities} style={{ marginTop: '0.5rem' }}>
                                                                        {f.extensions.map((ext, k) => (
                                                                            <span key={k} className={flightStyles.legAmenityTag}>{ext}</span>
                                                                        ))}
                                                                    </div>
                                                                )}

                                                                {/* Fares & baggage (lazy-loaded via booking options) */}
                                                                {f.bookingToken && (() => {
                                                                    const bd = bookingData[f.id];
                                                                    return (
                                                                        <div className={flightStyles.baggageSection}>
                                                                            {!bd && (
                                                                                <button className={flightStyles.baggageLoadBtn} onClick={() => loadBookingOptions(f)}>
                                                                                    <BagIcon /> Show fares &amp; baggage allowance
                                                                                </button>
                                                                            )}
                                                                            {bd?.loading && <div className={flightStyles.baggageLoading}>Loading fares &amp; baggage…</div>}
                                                                            {bd?.error && <div className={flightStyles.baggageError}>{bd.error}</div>}
                                                                            {bd?.data && (
                                                                                <>
                                                                                    {bd.data.baggageSummary?.length > 0 && (
                                                                                        <div className={flightStyles.bagSummary}>
                                                                                            <BagIcon />
                                                                                            <div className={flightStyles.bagSummaryTags}>
                                                                                                {bd.data.baggageSummary.map((b, k) => (
                                                                                                    <span key={k} className={flightStyles.bagTag}>{b}</span>
                                                                                                ))}
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                    <div className={flightStyles.fareList}>
                                                                                        {bd.data.options.map((opt, k) => (
                                                                                            <div key={k} className={flightStyles.fareCard}>
                                                                                                <div className={flightStyles.fareHead}>
                                                                                                    {opt.logos?.[0] && <img src={opt.logos[0]} alt={opt.bookWith} referrerPolicy="no-referrer" />}
                                                                                                    <div className={flightStyles.fareHeadText}>
                                                                                                        <span className={flightStyles.fareSeller}>{opt.bookWith}</span>
                                                                                                        {(opt.optionTitle || opt.fareType) && (
                                                                                                            <span className={flightStyles.fareType}>{opt.optionTitle || opt.fareType}</span>
                                                                                                        )}
                                                                                                    </div>
                                                                                                    {opt.price != null && <span className={flightStyles.farePrice}>{fmtPrice(opt.price)}</span>}
                                                                                                </div>
                                                                                                {opt.baggage?.length > 0 && (
                                                                                                    <div className={flightStyles.fareBags}>
                                                                                                        {opt.baggage.map((b, j) => (
                                                                                                            <span key={j} className={flightStyles.bagTag}><BagIcon /> {b}</span>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                )}
                                                                                                {opt.extensions?.length > 0 && (
                                                                                                    <div className={flightStyles.legAmenities}>
                                                                                                        {opt.extensions.map((ext, j) => (
                                                                                                            <span key={j} className={flightStyles.legAmenityTag}>{ext}</span>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                )}
                                                                                                {opt.bookingUrl && (
                                                                                                    <button className={flightStyles.bookBtn} onClick={() => bookNow(opt.bookingUrl, opt.bookingPostData)}>
                                                                                                        Book with {opt.bookWith}
                                                                                                    </button>
                                                                                                )}
                                                                                                {!opt.bookingUrl && opt.bookingPhone && (
                                                                                                    <span className={flightStyles.bookPhone}>Book by phone: {opt.bookingPhone}</span>
                                                                                                )}
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })()}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>

                                            {/* Price & action */}
                                            <div className={flightStyles.flightSide}>
                                                <div className={flightStyles.priceWrap}>
                                                    <span className={flightStyles.priceLabel}>{f.type || 'From'}</span>
                                                    <span className={flightStyles.price}>{fmtPrice(f.price)}</span>
                                                    <span className={flightStyles.pricePer}>{adults > 1 ? `for ${adults} travelers` : 'per person'}</span>
                                                </div>
                                                <button className={flightStyles.selectBtn}>Select flight</button>
                                            </div>
                                        </article>
                                    );
                                })}
                            </div>
                        )}
                    </section>
                </div>
            </main>
        </div>
    );
}
